import { GetAmbulatoryCids } from 'domain/usecases/ambulatory/get-ambulatory-cids'
import { NewAmbulatoryRepository } from 'repository/interfaces/new-ambulatory-repository'

export class RemoteGetAmbulatoryCids implements GetAmbulatoryCids {
  private readonly ambulatoryRepository: NewAmbulatoryRepository

  constructor(ambulatoryRepository: NewAmbulatoryRepository) {
    this.ambulatoryRepository = ambulatoryRepository
  }

  get(params: GetAmbulatoryCids.Params): Promise<GetAmbulatoryCids.Model> {
    return this.ambulatoryRepository.getAmbulatoryCids(params)
  }
}
